export default "__VITE_ASSET__CdQRZwBa__"